import { currencyPattern } from 'src/common/regex';
import { FormValidations } from 'src/components/form/constants';
import {
  OccupancyReport,
  OccupancyError,
  RevenueReport,
  BucketError,
} from 'src/types/tax';

const ERROR_DEDUCTIONS_GREATER_THAN_SALES = `Deductions can't be more than sales`;
const ERROR_MAX_DAYS = (daysInPeriod: number) =>
  `Days available can't be more than ${daysInPeriod}`;
const ERROR_OCCUPANCY_LESS_THAN_AVAILABILITY = `Occupancy can't be greater than the Available days`;

export const validateBuckets = (
  buckets: Array<RevenueReport>,
  enableDeductions?: boolean
): Array<BucketError> => {
  return buckets.map((bucket) => ({
    discounts: enableDeductions
      ? validateDiscount(bucket.discounts, bucket.revenue)
      : undefined,
    revenue: validateRevenue(bucket.revenue),
  }));
};

export const validateDiscount = (
  discount: number | undefined,
  revenue: number | undefined
): string | undefined => {
  if (discount === undefined) return FormValidations.ERROR_REQUIRED;
  if (typeof discount !== 'number' && Number.isNaN(Number(discount)))
    return FormValidations.ERROR_NUMBER;
  if (discount < 0) return FormValidations.ERROR_GREATER_THAN_ZERO;
  if (revenue !== undefined && Number(discount) > Number(revenue))
    return ERROR_DEDUCTIONS_GREATER_THAN_SALES;
  if (!currencyPattern.test(discount.toString()))
    return FormValidations.ERROR_CURRENCY;
};

export const validateRevenue = (
  revenue: number | undefined
): string | undefined => {
  if (revenue === undefined) return FormValidations.ERROR_REQUIRED;
  if (typeof revenue !== 'number' && Number.isNaN(Number(revenue)))
    return FormValidations.ERROR_NUMBER;
  if (revenue < 0) return FormValidations.ERROR_GREATER_THAN_ZERO;
  if (!currencyPattern.test(revenue.toString()))
    return FormValidations.ERROR_CURRENCY;
};

export const validateOccupancy = (
  occupancy: OccupancyReport,
  daysInPeriod: number
): OccupancyError => {
  return {
    available: validateAvailable(occupancy.available, daysInPeriod),
    occupied: validateOccupied(occupancy.occupied, occupancy.available),
  };
};

const validateAvailable = (
  available: number | undefined,
  daysInPeriod: number
): string | undefined => {
  if (available === undefined) return FormValidations.ERROR_REQUIRED;
  if (typeof available !== 'number') return FormValidations.ERROR_NUMBER;
  if (!Number.isInteger(available)) return FormValidations.ERROR_INTEGER;
  if (available < 0) return FormValidations.ERROR_GREATER_THAN_ZERO;
  if (available > daysInPeriod) return ERROR_MAX_DAYS(daysInPeriod);
};

const validateOccupied = (
  occupied: number | undefined,
  available: number | undefined
): string | undefined => {
  if (occupied === undefined) return FormValidations.ERROR_REQUIRED;
  if (typeof occupied !== 'number') return FormValidations.ERROR_NUMBER;
  if (!Number.isInteger(occupied)) return FormValidations.ERROR_INTEGER;
  if (occupied < 0) return FormValidations.ERROR_GREATER_THAN_ZERO;
  if (available) {
    if (occupied > available) return ERROR_OCCUPANCY_LESS_THAN_AVAILABILITY;
  }
};
